export function filterChildItem(quoteLine: any[]) {
  return quoteLine?.filter((line) => !line.isChildItem);
}

export function sortQuoteLines(quoteLines: any[], enableWarranty?: boolean) {
  const lines: any[] = [];
  if (!quoteLines || quoteLines.length === 0) {
    return lines;
  }

  const isContainsWarranty =
    quoteLines.some(
      (line: any) => line?.isWarrantySku && line?.parentLineNumber
    ) && enableWarranty;

  filterChildItem(quoteLines).forEach((line) => {
    if (
      line?.planId &&
      line?.planId !== '' &&
      line?.planApsid &&
      line?.planApsid !== ''
    ) {
      const lineIndex = lines?.findIndex(
        (l) => l?.planApsid === line?.planApsid
      );
      if (lineIndex !== -1) {
        lines[lineIndex].planOptions.push(line);
      } else {
        const planOptions = [line];
        lines.push({
          ...line,
          planOptions,
        });
      }
    } else if (isContainsWarranty) {
      if (!line?.isWarrantySku) {
        const warranties = quoteLines.filter(
          (childLine) =>
            childLine.isWarrantySku &&
            childLine.parentLineNumber === line.lineNumber
        );
        lines.push({
          ...line,
          warranties,
        });
      }
    } else {
      lines.push(line);
    }
  });
  lines.sort(
    (line1: any, line2: any) => line2.sequenceNumber - line1.sequenceNumber
  );
  return lines;
}
